import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { ScheduleEditTemplate } from 'components/Templates'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { fetchBread } from 'reducks/bread/operations'
import { getBread } from 'reducks/bread/selectors'
import { getBreadShortName } from 'lib/helper'

const ScheduleEdit: FC = () => {
  const dispatch = useDispatch()
  const path = useSelector((state: State) => state.router.location.pathname)
  // ブラウザバックしたときに異なるパスでbreadIdを判定してfetchすることを防ぐ
  const paths = /^\/schedule\/.+$/.test(path) ? path.split('/') : []
  const breadId = paths.length > 0 ? paths[paths.length - 1] : undefined
  const bread = useSelector((state: State) => getBread(state))
  useEffect(() => {
    if (!breadId || breadId === '') return
    dispatch(fetchBread(breadId))
  }, [breadId])
  if (!bread) return <></>
  return (
    <Layout title={`${getBreadShortName(bread)}の事前予約受付設定を編集する`}>
      <ScheduleEditTemplate bread={bread} />
    </Layout>
  )
}

export default ScheduleEdit
